// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewButton_view_button__N0Ygy {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease-in-out;
  width: 20px;
  height: 20px;
  margin: 0 15px;
}
.viewButton_view_button__N0Ygy img {
  width: 100%;
}
.viewButton_view_button__N0Ygy:hover {
  transform: scale(105%);
  transition: all 0.2s ease-in-out;
  background-color: rgba(50, 151, 107, 0.09);
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Buttons/ViewButton/viewButton.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EAEA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAAF;AAEE;EACE,WAAA;AAAJ;AAGE;EACE,sBAAA;EACA,gCAAA;EACA,0CAAA;EACA,kBAAA;AADJ","sourcesContent":[".view_button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n\n  transition: all 0.2s ease-in-out;\n  width: 20px;\n  height: 20px;\n  margin: 0 15px;\n\n  img {\n    width: 100%;\n  }\n\n  &:hover {\n    transform: scale(105%);\n    transition: all 0.2s ease-in-out;\n    background-color: rgba(50, 151, 107, 0.09);\n    border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view_button": `viewButton_view_button__N0Ygy`
};
export default ___CSS_LOADER_EXPORT___;
